import { useEffect, useRef } from 'react'
import Button from '@ui/components/Button/Button'
import Icon from '@ui/components/Icon/Icon'
import Tooltip from 'src/components/UI/Tooltip/Tooltip'
import styles from './WatchFolderButton.module.scss'

const LEARN_MORE_URL = 'https://support.verybusy.io/en/articles/14790812-auto-sync-uploads-from-desktop-folder-beta'

const TooltipContent = () => {
	const ref = useRef<HTMLSpanElement>( null )

	useEffect( () => {
		const el = ref.current
		const handler = ( e: MouseEvent ) => e.stopImmediatePropagation()
		el?.addEventListener( 'mousedown', handler )
		return () => el?.removeEventListener( 'mousedown', handler )
	}, [] )

	return (
		<span ref={ref} className={styles.WatchFolderButton__tooltipContent}>
			Auto-sync a folder on your computer.
			<a
				href={LEARN_MORE_URL}
				target="_blank"
				rel="noopener noreferrer"
				className={styles.WatchFolderButton__learnMore}
			>
				Learn more in our Help Center ↗
			</a>
		</span>
	)
}

const infoIcon = (
	<div
		className={styles.WatchFolderButton__infoIcon}
		onClick={e => e.stopPropagation()}
	>
		<Tooltip html={<TooltipContent />} interactive position="left">
			<Icon icon="info_outlined" size={15} color="#9CA3AF" />
		</Tooltip>
	</div>
)

const badge = <span className={styles.WatchFolderButton__badge}>Beta</span>

type WatchFolderButtonProps = {
	variant: 'dropdown' | 'outline'
	onClick: () => void
}

const WatchFolderButton = ( { variant, onClick }: WatchFolderButtonProps ) => {
	if ( variant === 'dropdown' ) {
		return (
			<div className="first-row" onClick={onClick}>
				<Icon className="icon" icon="folder-clock" color="var(--color-text-secondary)" size={20} />
				<h5 className="DropdownButtonItemText">Watch folder</h5>
				{badge}
				{infoIcon}
			</div>
		)
	}

	return (
		<Button
			variant="outline"
			size="sm"
			className={styles.WatchFolderButton}
			onClick={onClick}
		>
			<span className={styles.WatchFolderButton__outlineContent}>
				Watch folder
				{badge}
				{infoIcon}
			</span>
		</Button>
	)
}

export default WatchFolderButton
